import { Component, EventEmitter, Input, OnInit, Output, ChangeDetectorRef } from '@angular/core';
import { UsersService } from '@app/api/api';
import { ToastrService } from 'ngx-toastr';
import { MatDialog } from '@angular/material';
import { Store, select } from '@ngrx/store';
import { AppState } from '@app/core/reducers';
import { currentUser, isLoggedIn } from '@app/core/auth';
import { environment } from '@app/../environments/environment';
import { ModalCreateSignInUpComponent } from '@app/views/pages/sign-in-up/modal-create-sign-in-up/modal-create-sign-in-up.component';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'meu-ask-form',
  templateUrl: './ask-form.component.html',
  styleUrls: ['./ask-form.component.scss'],
})
export class AskFormComponent implements OnInit {
  @Input() isPopup: boolean = false;
  @Output() closeEvent = new EventEmitter<void>();

  questionText: string = '';
  selectedFiles: File[] = [];
  isLoading: boolean = false;
  isLogin: boolean = false;

  constructor(
    private usersService: UsersService,
    private cdr: ChangeDetectorRef,
    private toastr: ToastrService,
    private dialog: MatDialog,
    private store: Store<AppState>,
    private translate: TranslateService
  ) {}

  ngOnInit(): void {
    // isLoggedIn — có giá trị ngay khi Login action dispatch
    this.store.pipe(select(isLoggedIn)).subscribe(loggedIn => {
      if (loggedIn) {
        this.isLogin = true;
      } else {
        const token = localStorage.getItem(environment.authTokenKey);
        this.isLogin = !!(token && token.length > 10);
      }
      this.cdr.detectChanges();
    });

    this.store.pipe(select(currentUser)).subscribe((user) => {
      if (user) {
        this.isLogin = true;
        this.cdr.detectChanges();
      }
    });
  }

  onClose() {
    this.closeEvent.emit();
  }

  onFileSelected(event: any) {
    if (event.target.files && event.target.files.length > 0) {
      this.selectedFiles.push(event.target.files[0]);
    }
  }

  removeFile(index: number) {
    this.selectedFiles.splice(index, 1);
  }

  openModalSignIn() {
    this.dialog.open(ModalCreateSignInUpComponent, {
      width: '900px',
      data: {
        type: 'signin',
        returnUrl: location.pathname,
      },
    });
  }

  sendQuestion() {
    if (!this.isLogin) {
      if (this.isPopup) {
        this.onClose();
      }
      this.openModalSignIn();
      return;
    }

    if (!this.questionText || this.questionText.trim() === '') {
      this.toastr.warning(
        this.translate.instant('ASK_FORM.NOTIFICATIONS.REQUIRED_QUESTION'),
        this.translate.instant('ASK_FORM.NOTIFICATIONS.WARNING_TITLE')
      );
      return;
    }

    this.isLoading = true;

    this.usersService
      .apiUsersSendAskingEmailToAdminPost(this.questionText, this.selectedFiles)
      .subscribe(
        (res) => {
          this.isLoading = false;
          if (res && res.success) {
            this.toastr.success(
              this.translate.instant('ASK_FORM.NOTIFICATIONS.SUCCESS_MSG'),
              this.translate.instant('ASK_FORM.NOTIFICATIONS.SUCCESS_TITLE')
            );

            this.questionText = '';
            this.selectedFiles = [];

            if (this.isPopup) {
              this.onClose();
            }
          } else {
            this.toastr.error(
              res.message || this.translate.instant('ASK_FORM.NOTIFICATIONS.ERROR_MSG'),
              this.translate.instant('ASK_FORM.NOTIFICATIONS.ERROR_TITLE')
            );
          }
          this.cdr.detectChanges();
        },
        (err) => {
          this.isLoading = false;
          console.error(err);
          this.toastr.error(
            this.translate.instant('ASK_FORM.NOTIFICATIONS.SYSTEM_ERROR'),
            this.translate.instant('ASK_FORM.NOTIFICATIONS.ERROR_TITLE')
          );
          this.cdr.detectChanges();
        }
      );
  }
}
